import { apiSlice } from "./apiSlice";

const resourceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createResource: builder.mutation({
      query: (values) => ({
        url: "/resource",
        method: "POST",
        body: values,
      }),
    }),
  }),
});

export const { useCreateResourceMutation } = resourceApiSlice;
